/**
 * Estilo de células de calendário (hoje, passado, seleção). O dia atual usa
 * `static-gradient-bg` (mesmo fundo do shell / auth).
 */

export function localTodayDateKey(): string {
  const n = new Date();
  return `${n.getFullYear()}-${String(n.getMonth() + 1).padStart(2, '0')}-${String(n.getDate()).padStart(2, '0')}`;
}

export function isCalendarToday(dayKey: string): boolean {
  return dayKey === localTodayDateKey();
}

export function isCalendarPastDay(dayKey: string): boolean {
  return dayKey < localTodayDateKey();
}

const cellFocus =
  'focus:outline-none focus-visible:ring-2 focus-visible:ring-cyan focus-visible:ring-offset-1';

export function calendarDayButtonClassName(params: {
  dayKey: string;
  selected: boolean;
  hasData: boolean;
  /** Ex.: min-h-[4.5rem] sm:min-h-[5.5rem] */
  cellMinHeightClass: string;
}): string {
  const { dayKey, selected, hasData, cellMinHeightClass } = params;
  const todayKey = localTodayDateKey();
  const isToday = dayKey === todayKey;
  const isPast = dayKey < todayKey;

  const base = `${cellMinHeightClass} rounded-lg border text-left p-1.5 sm:p-2 transition-[background-color,box-shadow,filter,border-color] ${cellFocus}`;

  if (selected) {
    if (isToday) {
      return `${base} border-cyan static-gradient-bg ring-2 ring-cyan shadow-md shadow-cyan/25`;
    }
    if (isPast) {
      return `${base} border-cyan bg-slate-200/75 ring-1 ring-cyan/45 hover:bg-slate-200/88`;
    }
    return `${base} border-cyan bg-cyan/10 ring-1 ring-cyan/40`;
  }

  if (isToday) {
    return `${base} border-cyan/40 static-gradient-bg shadow-sm shadow-navy-dark/20 hover:brightness-[1.07]`;
  }

  if (isPast) {
    if (hasData) {
      return `${base} border-slate-200/80 bg-slate-200/40 hover:bg-slate-200/55`;
    }
    return `${base} border-slate-200/70 bg-slate-100/55 hover:bg-slate-200/40`;
  }

  if (hasData) {
    return `${base} border-border-light bg-[#fafbfc] hover:bg-cyan/5`;
  }
  return `${base} border-border-light/80 bg-white hover:bg-[#f8fafc]`;
}

/** Número do dia no topo da célula. */
export function calendarDayNumberClassName(dayKey: string, selected: boolean): string {
  if (isCalendarToday(dayKey)) return 'text-white drop-shadow-sm';
  if (selected) return 'text-cyan-dark';
  return 'text-navy-dark';
}

/** Textos secundários dentro da célula (métricas, traço). */
export function calendarDaySecondaryTextClassName(dayKey: string): string {
  return isCalendarToday(dayKey) ? 'text-white/88' : 'text-text-muted';
}
